module.exports = __webpack_public_path__ + "img/3.1.33f33a73.png";